<template>
<div class="area scroller">
  <transition name="fadein">
    <router-view class="h-full"></router-view>
  </transition>
</div>
</template>

<script>
export default {
  mounted () {
    this.$nextTick(() => {
      document.body.style.background = `linear-gradient(180deg, #2c4fb1, #0a1a47);`
      document.querySelector('#app').style.background = `linear-gradient(180deg, #2c4fb1, #0a1a47);`
    })
  }
}
</script>

<style scoped>
.area {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  background: linear-gradient(180deg, #2c4fb1, #0a1a47);
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.fadein-enter-active{
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
  transition: opacity 0.5s;
  opacity: 1;
}

.fadein-leave-active {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
  transition: opacity 0.5s;
  opacity: 1;
}

.fadein-enter /* .fadein-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: perspective(100vmax) translateZ(-400px) rotateX(10deg) translateY(-150%); */
}

.fadein-leave-to /* .fadein-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: perspective(100vmax) translateZ(-400px) rotateX(10deg) translateY(-150%); */
}
</style>
